import { useEffect, useRef } from 'react'

import { AccessTokenStateEnum } from '../../../../types/enums'
import { Auth } from '../../modules/auth/Auth'

const useRefreshTokenLoop = () => {
  const isRefreshingRef = useRef<boolean>(false)
  const refreshTimerRef: any = useRef<NodeJS.Timeout>(null)
  const refreshIntervalSeconds = 60

  const checkAndHandleAccessTokenExpiration = () => {
    if (isRefreshingRef.current) {
      // prevent double refresh
      return
    }

    const { tokenState /* , debugData */ } = Auth.getAccessTokenData()

    /* 
    Perzistentni ulozeni tu bude spise SPAM co vytlaci predchozi fetche atp.
    
    PersistentLogger.log({
      message: 'CHECKING ACCESS TOKEN',
      origin: 'userRefreshTokenLoop',
      debugData,
    })
    */

    // console.log('CHECKING ACCESS TOKEN', debugData)

    if (tokenState === AccessTokenStateEnum.expiredToken) {
      // Fetch new token
      isRefreshingRef.current = true
      Auth.fetchNewAccessToken({ origin: 'useRefreshTokenLoop' }).finally(() => {
        isRefreshingRef.current = false
      })
    }
  }

  useEffect(() => {
    checkAndHandleAccessTokenExpiration()

    refreshTimerRef.current = setInterval(() => {
      checkAndHandleAccessTokenExpiration()
    }, refreshIntervalSeconds * 1000)

    return () => {
      clearInterval(refreshTimerRef.current)
    }
  }, [])
}

export default useRefreshTokenLoop
